document.addEventListener('DOMContentLoaded', function () {
	const script = document.createElement('script');
	script.src = 'https://d7on86vdidm2.cloudfront.net/chatbot.bundle.js?versionId=Cflcxhyp9GaVBstjNOnyTf6.i7gSIWLj';
	script.async = true;
	script.onload = function () {
		if (window.renderChatBot) {
			window.renderChatBot(
				'chat-container',
				'https://gqizegnlxa2uirll4rw6ceh46m0guwzt.lambda-url.eu-west-2.on.aws/',
				'https://3nb4x7wkfjugrqtkrujlbmujju0fxneq.lambda-url.eu-west-2.on.aws/',
				'eu-west-2:70a9dab1-178a-430e-b98f-b31bd8fc4ac1',
				'https://d7on86vdidm2.cloudfront.net', // CloudFront CDN URL to help fetch images
				'rC16LJu296evF4K9TASe35SlGbcgT2he'
			);
		} else {
			console.error('renderChatBot function is not available.');
		}
	};

	document.body.appendChild(script);
});
